export function formatDate(date: string): string {
  const [year, month, day] = date.split("-");
  return `${day || 0}.${month || 0}.${year || 0}`;
}
